<template>
  <div class="sider-menu-wrapper">
    <!-- Logo -->
    <slot name="top"></slot>
    <!-- 展开式菜单 -->
    <Menu
      ref="menu"
      width="auto"
      v-show="!shrink"
      :theme="theme"
      :accordion="accordion"
      :active-name="selectName"
      :open-names="openedNames"
      @on-select="handleSelect"
    >
      <template v-for="item in menuList">
        <!-- 有子级，并且只有1个 -->
        <template v-if="item.children && item.children.length === 1">
          <sider-menu-item
            v-if="showChildren(item)"
            :key="`item-${item.name}`"
            :parent-item="item"
          ></sider-menu-item>
          <menu-item
            v-else
            :name="getNameOrHref(item, true)"
            :key="`menu-${item.children[0].name}`"
          >
            <Icon :type="item.children[0].icon || ''" />
            <span>{{ showTitle(item.children[0]) }}</span>
          </menu-item>
        </template>
        <template v-else>
          <sider-menu-item
            v-if="showChildren(item)"
            :key="`menu-${item.name}`"
            :parent-item="item"
          ></sider-menu-item>
          <menu-item
            v-else
            :name="getNameOrHref(item)"
            :key="`menu-${item.name}`"
          >
            <Icon :type="item.icon || ''" />
            <span>{{ showTitle(item) }}</span>
          </menu-item>
        </template>
      </template>
    </Menu>

    <!-- 缩起式菜单 -->
    <div class="menu-shrink" v-show="shrink" :list="menuList">
      <template v-for="item in menuList">
        <sider-menu-shrink
          hide-title
          v-if="item.children && item.children.length >= 1"
          :key="`drop-menu-${item.name}`"
          :theme="theme"
          :parent-item="item"
          @on-click="handleSelect"
        >
        </sider-menu-shrink>
        <Tooltip
          v-else
          transfer
          placement="right"
          :key="`drop-${item.name}`"
          :content="
            (item.meta && item.meta.title) ||
            (item.children && item.children[0] && item.children[0].meta.title)
          "
        >
          <a
            type="text"
            class="drop-menu-a"
            @click="handleSelect(getNameOrHref(item, true))"
          >
            <Icon
              size="20"
              :color="textColor"
              :type="item.icon || (item.children && item.children[0].icon)"
            />
          </a>
        </Tooltip>
      </template>
    </div>
  </div>
</template>

<script>
import SiderMenuItem from './sider-menu-item';
import SiderMenuShrink from './sider-menu-shrink';
import mixin from './mixin.js';
import './sider-menu.less';

export default {
  name: 'SideMenu',
  mixins: [mixin],
  components: {
    SiderMenuItem,
    SiderMenuShrink,
  },
  props: {
    menuList: {
      type: Array,
      default() {
        return [];
      },
    },
    shrink: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      default: 'dark',
      validator(value) {
        // 后面可移除
        return ['dark', 'light'].includes(value);
      },
    },
    accordion: Boolean,
    activeName: {
      type: String,
      default: '',
    },
    openNames: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      openedNames: [],
    };
  },
  methods: {
    handleSelect(name) {
      this.$emit('on-select', name);
    },
    // 通过选择的菜单，获得打开菜单
    getOpenedNamesByActiveName(name) {
      return this.$route.matched
        .map((item) => item.name)
        .filter((item) => item != name);
    },
    // 更新展开菜单 list
    updateOpenName(name) {
      if (name === 'home') {
        this.openedNames = [];
      } else {
        this.openedNames = this.getOpenedNamesByActiveName(name);
      }
    },
  },
  watch: {
    activeName(name) {
      if (this.accordion) {
        this.openedNames = this.getOpenedNamesByActiveName(name);
      } else {
        this.openedNames = [
          ...new Set([
            ...this.openedNames,
            this.getOpenedNamesByActiveName(name),
          ]),
        ];
      }
    },
    openNames(newNames) {
      this.openedNames = newNames;
    },
    openedNames() {
      this.$nextTick(() => {
        this.$refs.menu.updateOpened();
      });
    },
  },
  computed: {
    textColor() {
      return this.theme === 'dark' ? '#495060' : '#fff';
    },
    selectName() {
      let selectMenu = this.activeName;
      let metas = this.$route.matched.map((item) => item.meta.select);
      metas.map((item) => {
        if (item) selectMenu = item;
      });
      return selectMenu;
    },
  },
  mounted() {
    this.openedNames = [
      ...new Set([...this.openedNames, this.getOpenedNamesByActiveName(name)]),
    ];
  },
};
</script>
